import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    orderBy,
    query,
    Timestamp,
    where,
    writeBatch
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Stack,
    Pagination,
    Chip
} from "@mui/material";

import {
    Visibility,
    Close,
    SwapHoriz
} from "@mui/icons-material";

const colors = {
    darkGreen: '#06362D',
    calPolyGreen: '#155332',
    vanilla: '#DEE2B1',
    gold: '#FFD500',
    goldenrod: '#D1A505'
};

function Pendingpayments() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [bookings, setbookings] = useState([]);
    const [username, setusername] = useState();
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [searchText, setsearchText] = useState("");
    const [bookingId, setbookingId] = useState("");
    const [requestType, setrequestType] = useState("Exchange Room");
    const [requestNote, setrequestNote] = useState("");
    const [roomUsed, setroomUsed] = useState("No");

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers();
        });
    }, []);

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false);
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (searchText === '') {
            fetchData1();
        } else {
            fetchData2();
        }
    }, [searchText]);

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'reservations'), orderBy("createdAt", "asc"), where('remaining', '>', 0));
            onSnapshot(q, (querySnapshot) => {
                setbookings(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
                setCurrentPage(1);
            });
        } catch (error) {
            console.log(error.message);
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = bookings.filter((item) =>
                item.data.customers.custname.toUpperCase().includes(searchText.toUpperCase())
            );
            setbookings(filteredData);
            setCurrentPage(1);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const storeRequest = async () => {
        if (!bookingId || !requestType || !requestNote) {
            Toast.fire({ icon: "error", title: 'Request Note or Request Type should not be blank' });
            return;
        }

        await addDoc(collection(db, 'approvals'), {
            bookingid: bookingId,
            requestType: requestType,
            requestNote: requestNote,
            status: 'Pending',
            rejectedreason: '',
            updatedat: "",
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
        });

        setrequestNote("");
        Toast.fire({ icon: "success", title: 'Approval Request send to the GM' });
    }

    const cancleBooking = async () => {
        const bookingRef = doc(db, "reeservations", bookingId);
        const batch = writeBatch(db);

        batch.update(bookingRef, { status: "Canceled" });

        const checkinDetailsQuery = query(collection(db, 'checkindetails'), where('bookingid', '==', bookingId));
        const checkinDetailsSnapshot = await getDocs(checkinDetailsQuery);
        checkinDetailsSnapshot.docs.forEach(item => {
            const checkinRef = doc(db, "checkindetails", item.id);
            batch.update(checkinRef, { status: "Canceled" });
        });

        const payHistoryQuery = query(collection(db, 'payhistory'), where('bookingid', '==', bookingId));
        const payHistorySnapshot = await getDocs(payHistoryQuery);
        payHistorySnapshot.docs.forEach(item => {
            const payHistoryRef = doc(db, "payhistory", item.id);
            batch.update(payHistoryRef, { status: "Canceled" });
        });

        const bookingSnap = await getDoc(bookingRef);
        const rooms = bookingSnap.data().rooms;
        rooms.forEach(room => {
            const roomRef = doc(db, "roomdetails", room.roomid);
            const status = roomUsed === 'Yes' ? 'Cleaning' : 'Available';
            batch.update(roomRef, { status });
        });

        await addDoc(collection(db, 'logs'), {
            bookingid: bookingId,
            customerId: bookingSnap.data().customerId,
            customers: bookingSnap.data().customers,
            rooms: rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Booking Cancellation',
        });

        await batch.commit();
        Toast.fire({ icon: "success", title: 'Room Successfully Canceled' });
    }

    // Pagination calculations
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = bookings.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(bookings.length / rowsPerPage);

    return (
        <Box sx={{ bgcolor: colors.darkGreen, minHeight: "100vh", color: colors.vanilla, p: { xs: 2, md: 1 } }}>
            <div className="container-fluid p-0">
                <div className="row mb-3">
                    <div className="col-sm-12">
                        <Typography variant="h5" fontWeight={800} sx={{ color: colors.vanilla }}>
                            Pending Payments
                        </Typography>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <Card sx={{ borderRadius: 3, border: `1px solid ${colors.goldenrod}`, bgcolor: colors.calPolyGreen, color: colors.vanilla, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.3)" }}>
                            <CardContent sx={{ p: 3 }}>
                                <div className="row mb-3">
                                    <div className="col-sm-4">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Search customer..."
                                            value={searchText}
                                            onChange={(e) => setsearchText(e.target.value)}
                                            InputLabelProps={{ style: { color: colors.vanilla } }}
                                            InputProps={{
                                                style: { color: colors.vanilla }
                                            }}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "8px",
                                                    backgroundColor: colors.darkGreen,
                                                    "& fieldset": { borderColor: colors.goldenrod },
                                                    "&:hover fieldset": { borderColor: colors.gold },
                                                    "&.Mui-focused fieldset": { borderColor: colors.gold }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "8px", border: `1px solid ${colors.goldenrod}`, backgroundColor: "transparent" }}>
                                    <Table size="small">
                                        <TableHead sx={{ bgcolor: colors.darkGreen }}>
                                            <TableRow>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Sr</TableCell>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Action</TableCell>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Customer</TableCell>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Check-in</TableCell>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Check-out</TableCell>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Rooms</TableCell>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Plans</TableCell>
                                                <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Adults</TableCell>
                                                <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Total</TableCell>
                                                <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Paid</TableCell>
                                                <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Remaining</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {currentRows.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={11} align="center" sx={{ py: 4, color: colors.vanilla, opacity: 0.7 }}>
                                                        No Records Found
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            {currentRows.map((item, index) => (
                                                <TableRow key={item.id} hover sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' } }}>
                                                    <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{indexOfFirstRow + index + 1}</TableCell>

                                                    <TableCell sx={{ borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        <Stack direction="row" spacing={0.5}>
                                                            <IconButton
                                                                size="small"
                                                                sx={{ color: colors.gold }}
                                                                href={`reservation-details/${item.id}`}
                                                            >
                                                                <Visibility fontSize="small" />
                                                            </IconButton>

                                                            {item.data.approval1 === "Yes" && (
                                                                <IconButton size="small" sx={{ color: colors.vanilla }}>
                                                                    <SwapHoriz fontSize="small" />
                                                                </IconButton>
                                                            )}

                                                            {item.data.approval2 === "Yes" && (
                                                                <IconButton
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={() => setbookingId(item.id)}
                                                                >
                                                                    <Close fontSize="small" />
                                                                </IconButton>
                                                            )}
                                                        </Stack>
                                                    </TableCell>

                                                    <TableCell sx={{ borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        <Typography fontWeight={600} sx={{ color: colors.gold, fontSize: '0.85rem' }}>
                                                            {item.data.customers.custname}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: colors.vanilla, opacity: 0.8 }}>
                                                            {item.data.customers.mobile}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        {moment(item.data.checkindate).format("DD/MM/YYYY")}
                                                    </TableCell>

                                                    <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        {moment(item.data.checkoutdate).format("DD/MM/YYYY")}
                                                    </TableCell>

                                                    <TableCell sx={{ borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        {item.data.rooms.map((r, i) => (
                                                            <Chip
                                                                key={i}
                                                                label={r.roomno}
                                                                size="small"
                                                                sx={{ mr: 0.5, mb: 0.5, bgcolor: colors.darkGreen, color: colors.vanilla, border: `1px solid ${colors.goldenrod}`, fontSize: '0.65rem' }}
                                                            />
                                                        ))}
                                                    </TableCell>

                                                    <TableCell sx={{ borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        {item.data.rooms.map((r, i) => (
                                                            <Chip
                                                                key={i}
                                                                label={r.planname}
                                                                size="small"
                                                                sx={{ mr: 0.5, mb: 0.5, bgcolor: colors.darkGreen, color: colors.vanilla, border: `1px solid ${colors.goldenrod}`, fontSize: '0.65rem' }}
                                                            />
                                                        ))}
                                                    </TableCell>

                                                    <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.adults}</TableCell>

                                                    <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        ₹ {item.data.totalamount.toFixed(2)}
                                                    </TableCell>

                                                    <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        ₹ {item.data.advance.toFixed(2)}
                                                    </TableCell>

                                                    <TableCell align="right" sx={{ color: colors.gold, fontWeight: 700, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                        ₹ {item.data.remaining.toFixed(2)}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {/* Pagination */}
                                <Box display="flex" justifyContent="center" mt={3}>
                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={(e, v) => setCurrentPage(v)}
                                        color="primary"
                                        size="small"
                                    />
                                </Box>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        </Box>
    );
}

export default Pendingpayments;